/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { LocalViewId } from '@jira/polaris__domain-view/src/ViewKind.types.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { Props, State } from './NavigationView.types.tsx';
import { withRefreshBlocker } from './withRefreshBlocker.tsx';
import { findView, isFakeId, updateContainerState } from './updateContainerState.tsx';

export const deleteViewSet = (localId: LocalViewId): Action<State, Props> =>
	withRefreshBlocker(
		async (
			{ setState, getState },
			{ navigationRemote, cloudId, containerId, onFailure, onSuccess },
		) => {
			if (
				!cloudId ||
				!containerId ||
				!navigationRemote ||
				getState().containers[containerId]?.isLoading ||
				!getState().containers[containerId]?.initialized
			) {
				return;
			}

			const { view } = findView(getState().containers[containerId], localId);

			if (!view) {
				return;
			}

			if (isFakeId(view.id)) {
				setState(
					updateContainerState(getState(), containerId, {
						views: getState().containers[containerId].views.filter(
							(innerView) => !innerView.views || innerView.localId !== localId,
						),
					}),
				);
				return;
			}

			setState(
				updateContainerState(getState(), containerId, {
					views: [
						...getState().containers[containerId].views.map((innerView) =>
							innerView.localId === localId
								? { ...innerView, isRenaming: false, isLocked: true }
								: innerView,
						),
					],
				}),
			);

			try {
				await navigationRemote.deleteView({
					viewId: view.id,
				});
				setState(
					updateContainerState(getState(), containerId, {
						views: getState().containers[containerId].views.filter(
							(innerView) => innerView.viewType !== 'SECTION' || innerView.localId !== localId,
						),
					}),
				);
				onSuccess?.('deleteSection');
				// oxlint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (error: any) {
				setState(
					updateContainerState(getState(), containerId, {
						views: [
							...getState().containers[containerId].views.map((innerView) =>
								innerView.localId === localId ? { ...innerView, isLocked: false } : innerView,
							),
						],
					}),
				);

				onFailure?.(error, 'deleteSection');
			}
		},
	);
